// @ts-ignore
import { ImageLoading } from '../../components/ImageLoading';
export const GoroundIcon = (props: any) => {
    return (<div>
        {props.vertical ? <ImageLoading src={require('./goroundText.png')} width="100%" />:
        <ImageLoading src={require('./goroundIcon.png')} width="100%" />}
    </div>)
}